import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { site } from "@/lib/siteContent";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-navy/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-home-link" className="shrink-0">
          <Logo variant="light" />
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {site.nav.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className="text-[13px] font-medium tracking-wide text-white/80 hover:text-gold transition-colors duration-300 uppercase"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:block">
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="group inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-navy px-5 py-2.5 text-[12px] font-bold uppercase tracking-[0.18em] transition-all duration-300 hover:translate-x-0.5"
          >
            Get In Touch
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ease-out bg-navy-dark border-t border-white/10 ${
          open ? "max-h-[520px]" : "max-h-0"
        }`}
        data-testid="nav-mobile-menu"
      >
        <ul className="px-6 py-6 flex flex-col gap-4">
          {site.nav.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={() => setOpen(false)}
                className="block py-2 text-white/90 hover:text-gold text-base font-medium uppercase tracking-wide"
              >
                {item.label}
              </a>
            </li>
          ))}
          <li className="pt-2">
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="inline-block bg-gold text-navy px-5 py-3 font-bold uppercase tracking-[0.18em] text-xs"
            >
              Get In Touch
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
}
